__turbopack_context__.v({
  "categories": "service-catalog-module__jg5yvG__categories",
  "category": "service-catalog-module__jg5yvG__category",
  "count": "service-catalog-module__jg5yvG__count",
  "subcategories": "service-catalog-module__jg5yvG__subcategories",
  "withSidebar": "service-catalog-module__jg5yvG__withSidebar",
});
